__turbopack_context__.v({
  "has__offers": "MetaLabel-module__m3xNiW__has__offers",
  "status": "MetaLabel-module__m3xNiW__status",
  "status__active": "MetaLabel-module__m3xNiW__status__active",
  "status__archived": "MetaLabel-module__m3xNiW__status__archived",
  "status__default": "MetaLabel-module__m3xNiW__status__default",
  "status__inactive": "MetaLabel-module__m3xNiW__status__inactive",
  "status__progress": "MetaLabel-module__m3xNiW__status__progress",
  "zero__offers": "MetaLabel-module__m3xNiW__zero__offers",
});
